import React from 'react'
import { Box } from '@chakra-ui/react'
import { Text ,Input} from '@chakra-ui/react'
import { Stack,VStack,HStack } from '@chakra-ui/react'
import { Heading ,Button} from '@chakra-ui/react'
import {AiOutlineCopyright,AiOutlineLinkedin,AiOutlineInstagram,AiOutlineGithub,AiOutlineSend} from "react-icons/ai"

const Footer = () => {
  return (
    <Box minH={"40"} bgColor={"blackAlpha.900"} p={["4","16"]} >
      <Stack direction={["column","row"]} color={"white"} alignItems={"center"} >
          <VStack w={"full"} p={"4"}>
            <Heading size={"md"} color={"white"} textAlign={"center"}> SUBSCRIBE TO GET UPDATES</Heading>
            <HStack borderBottom={"2px solid white"} py={"4"} ><Input placeholder='Enter Email here...' outline={"none"} border={"none"} borderRadius={"none"} focusBorderColor='none'/>
             <Button variant={"ghost"} p={0} borderRadius={"0 20px 20px 0"} colorScheme='purple'><AiOutlineSend/></Button> </HStack>
          </VStack>
          <VStack w={"full"} borderLeft={["none","2px solid white"] } borderRight={["none","2px solid white"]} p={"4"}>
              <Heading size={"xl"} >VIDEO HUB</Heading>
              <Stack direction={["column","row"]}><Text>All Rights Reserved </Text>
              <HStack><AiOutlineCopyright/> <Text>saurabhk1410</Text> </HStack> </Stack>
              
          </VStack>
          <VStack w={"full"} p={"4"}>
            <Heading size={"md"}>SOCIAL MEDIA</Heading>
           
<a href="https://www.linkedin.com/in/saurabhkumar-sharma-687767298" target='blank'><HStack><AiOutlineLinkedin/><Text>LinkedIn</Text></HStack> </a>
<a href="https://github.com/saurabhk1410" target='blank'><HStack><AiOutlineGithub/><Text>Github</Text></HStack> </a>
<a href="https://instagram.com/saurabh._.3" target='blank'><HStack><AiOutlineInstagram/><Text>Instagram</Text></HStack> </a>

          

          </VStack>
      </Stack>
    
    </Box>
  )
}

export default Footer